import { useState } from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import ProjectsComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../Common/SelectDialog ";

import { toast } from "react-toastify";
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const dialogStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "60vw",
};

const optionStyle = {
  padding: "10px",
  borderBottom: "1px solid #ddd",
  cursor: "pointer",
};
const closeBtn = {
  float: "right",
  marginTop: -18,
  fontSize: 18,
  marginRight: -8,
};
const AmenitiesDialog = ({
  AmenitiesData,
  selectedData,
  flag,
  setselectedData,
  onClose,
  onSelect,
}) => {
  

  const handleDecrease = (id) => {
    setselectedData((prev) =>
      prev
        .map((item) =>
          item.UnitFurnishingID === id
            ? { ...item, Quantity: item.Quantity - 1 }
            : item,
        )
        .filter((item) => item.Quantity > 0),
    );
  };

  return (
    <div style={overlayStyle}>
      <div style={dialogStyle} className="dialoggs">
        <div style={closeBtn}>
          <i
            className="ri-close-line"
            onClick={() => {
              onClose();
            }}
          />
        </div>

        <h5>{flag == 1 ? "Society Amenities" : "Property Furnishing"}</h5>
        <div className="dialogcontent">
          <ul className="amenities">
            {AmenitiesData?.map((amenity, index) => {
              return (
                <li
                  style={{
                    backgroundColor: selectedData?.some((item) =>
                      flag === 1
                        ? item.PropertyAmenitiesID ===
                          amenity.PropertyAmenitiesID
                        : item.UnitFurnishingID === amenity.UnitFurnishingID,
                    )
                      ? "#f0fff0"
                      : "transparent",
                    border: selectedData?.some((item) =>
                      flag === 1
                        ? item.PropertyAmenitiesID ===
                          amenity.PropertyAmenitiesID
                        : item.UnitFurnishingID === amenity.UnitFurnishingID,
                    )
                      ? "1px solid #16a34a"
                      : "1px solid transparent",
                  }}
                  onClick={() => onSelect(amenity)}
                  key={index}
                >
                  <img
                    src={
                      flag === 1
                        ? amenity?.PropertyAmenitiesIcon
                        : amenity?.UnitFurnishingIcon
                    }
                    style={{ height: 50, width: 50 }}
                  />
                  <span>
                    {flag === 1
                      ? amenity?.PropertyAmenities
                      : amenity?.UnitFurnishing}
                  </span>
                  {flag === 2 && amenity.Count === "Y" && selectedData?.some((item) => item.UnitFurnishingID === amenity.UnitFurnishingID) && (
                    <div className="qty">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDecrease(amenity.UnitFurnishingID);
                          }}
                        >
                          -
                        </button>

                        <span>
                          {selectedData?.find(
                            (item) =>
                              item.UnitFurnishingID ===
                              amenity.UnitFurnishingID,
                          )?.Quantity || 0}
                        </span>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onSelect(amenity);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={() => onClose()}
            style={{
              backgroundColor: "white",
              border: "1px solid #16a34a",
              color: "#16a34a",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={() => onClose()}
            style={{
              backgroundColor: "#16a34a",
              border: "1px solid #16a34a",
              color: "white",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default AmenitiesDialog;
